export default __webpack_public_path__ + "static/media/Available1.8424061b.svg";